<script>
	export let data;
	export let type;
	import { slide } from 'svelte/transition';

	import { changeHash } from '../../../scripts/change_hash';
	import { customAlert } from '../../../scripts/custom_alert';

	import {
		isWideScreen,
		isMenuClosed,
		isMobile,
		isSublistClosed,
		isMenuHeaderDataNeeded,
		clinicsNum,
		isNewDataChanged,
	} from '../../../stores/variables';

	if (data) {
		data.forEach((link) => {
			if (!link.options) {
				link.options = {
					hidden: false,
					sendButton: false,
					requestUrl: false,
					headerData: true,
				};
			}
		});
	}

	export let parentData = '';
	export let parentNumber = '';

	export let updateData;

	function forward(link, i) {
		if (!link.sublist && !link.active) {
			changeHash(type, link.hash, { navigate: true });
		}

		if (parentData) {
			parentData.forEach((_link, j) => {
				if (parentNumber != j) {
					_link.selected = false;
					_link.active = false;
					if (_link.sublist) {
						_link.sublist.forEach((_sublink) => {
							_sublink.selected = false;
							_sublink.active = false;
						});
					}
				}
			});
		}

		if (link.sublist) {
			data.forEach((_link, j) => {
				if (i != j) {
					_link.selected = false;

					if (_link.sublist) {
						let isActive = false;
						_link.sublist.forEach((_sublink) => {
							if (_sublink.active) isActive = true;
						});
						if (!isActive) _link.active = false;
					} else {
						_link.active = false;
					}
				}
			});

			let isSubActive = false;
			link.sublist.forEach((_sublink) => {
				if (_sublink.active) isSubActive = true;
			});

			if (!isSubActive) link.active = !link.active;
			link.selected = !link.selected;

			if (link.level == 0) {
				link.selected
					? ($isSublistClosed = false)
					: ($isSublistClosed = true);
			}
		} else {
			link.level == 0 && ($isSublistClosed = true);
			!$isWideScreen && ($isMenuClosed = true);
			data.forEach((_link, j) => {
				if (i != j) {
					_link.selected = false;
					_link.active = false;

					if (_link.sublist) {
						_link.sublist.forEach((_sublink) => {
							_sublink.active = false;
							_sublink.selected = false;
						});
					}
				}
			});

			link.selected = true;
			link.active = true;
		}

		$isMenuHeaderDataNeeded = link.options.headerData;

		updateData();
	}

	async function linkHandler(link, i) {
		if ($isNewDataChanged) {
			const confirm = await customAlert('Отменить изменения?', ['Да']);
			if (confirm == 'Да') {
				forward(link, i);
				$isNewDataChanged = false;
			}
		} else {
			forward(link, i);
		}
	}
</script>

{#if data}
	<ul
		class="list {parentNumber ? 'sublist' : ''} scrollbar {$isMenuClosed
			? 'menu-closed'
			: 'menu-opened'} {$isMobile ? 'mobile' : 'not_mobile'}"
		in:slide={!$isMenuClosed ? { duration: 400 } : { duration: 0 }}
		out:slide={!$isMenuClosed ? { duration: 400 } : { duration: 0 }}
	>
		{#each data as link, i}
			{#if !link.options.hidden}
				<li class="list__item list__item{link.level}">
					<span
						on:click={() => linkHandler(link, i)}
						class:selected={link.selected}
						class:active={link.active}
					>
						{#if link.icon}
							<b class={link.icon} />
						{/if}
						{link.name}
						{#if link.sublist}
							<i class="fas fa-chevron-right " />
						{/if}
						{#if link.counter}
							<div class="list__item-counter">
								{#if link.counter === 'orgscounter' && $clinicsNum}
									<span>{$clinicsNum}</span>
								{/if}
							</div>
						{/if}
					</span>
					{#if link.sublist && link.selected}
						<svelte:self
							data={link.sublist}
							parentData={data}
							parentNumber={i}
							{updateData}
							{type}
						/>
					{/if}
				</li>
			{/if}
		{/each}
	</ul>
{/if}

<style lang="scss">
	.list {
		display: flex;
		flex-direction: column;
		&__item {
			display: flex;
			flex-direction: column;

			&-counter {
				margin: 0 0 0 auto;
				flex-shrink: 0;
				padding-left: 5px;
				> span {
					background-color: var(--color-1);
					border-radius: 20px;
					height: 20px;
					min-width: 20px;
					padding: 5px;
					font-size: 12px;
					margin: 1px 1px 0 0;
					display: flex;
					align-items: center;
					justify-content: center;
					font-weight: bold;
					flex-shrink: 0;
					color: var(--text-main-1);
					word-break: normal !important;
				}
			}

			&0 {
				> span {
					padding: 16px 24px;
					font-size: 16px;
					font-weight: 700;
					display: flex;
					transition: color 0.3s ease;
					color: var(--text-gray-1);
					cursor: pointer;

					> b {
						width: 18px;
						margin: 0 15px 0 0;
						display: flex;
						align-items: center;
						justify-content: center;
						flex-shrink: 0;
						font-weight: 300;
						pointer-events: none;
					}

					> i {
						margin: 0 0 0 auto;
						display: flex;
						align-items: center;
						justify-content: center;
						flex-shrink: 0;
						font-weight: 300;
						pointer-events: none;
						&::before {
							margin: 0 0 0 10px;
							transition: transform 0.3s ease;
							font-size: 13px;
							font-weight: 700;
							@media (max-width: 991px) {
								font-size: 20px;
								font-weight: 500;
							}
						}
					}
				}
			}
			&1 {
				> span {
					padding: 10px 24px 10px 54px;
					font-size: 13px;
					border-left: 4px solid transparent;
					transition: border-color 0.1s ease, color 0.3s ease,
						background-color 0.3s ease;
					cursor: pointer;
					color: var(--text-gray-1);

					&.active {
						border-color: var(--color-1);
						background-color: var(--bg-black-1-active);
					}
				}
			}

			> span {
				&.active {
					color: var(--text-gray-2);
				}
				&.selected {
					color: var(--text-main-1);
					> i {
						&::before {
							transform: rotate(90deg);
						}
					}
				}
			}
		}
	}
	.sublist {
		display: flex;
	}

	@media (max-width: 991px) {
		.menu-closed {
			flex-direction: row;
			.list {
				&__item {
					&0 {
						> span {
							font-weight: 400;
							border-bottom: solid 5px transparent;
							white-space: nowrap;
							&.selected {
								border-color: var(--color-1);
							}
							> i {
								display: none;
							}
							> b {
								display: none;
							}
						}
					}
					&1 {
						> span {
							white-space: nowrap;
							border-radius: 4px;
							padding: 6px 12px;
							border: none;
						}
					}
				}
			}
			.sublist {
				position: absolute;
				top: 100%;
				left: 0;
				background: var(--bg-black-2);
				width: 100%;
				height: 60px;
				padding: 0 24px;
				align-items: center;
				overflow-x: overlay;
			}
		}
		.menu-opened {
			.list {
				&__item {
					&0 {
						border-bottom: 1px solid var(--border-gray-2);
						> span {
							font-size: 20px;
							line-height: 28px;
							> b {
								font-weight: 1000;
							}
						}
					}
					&1 {
						> span {
							padding: 10px 24px 10px 64px;
							font-size: 16px;
							line-height: 24px;
						}
					}
				}
			}
		}
	}
</style>
